<template>
  <div
    :class="'player-' + youtubeId"
    data-plyr-provider="youtube"
    :data-plyr-embed-id="youtubeId"
  ></div>
</template>

<script>
import plyr from "plyr";

export default {
  name: "YouTubePlayer",
  data() {
    return {
      players: null
    };
  },
  props: ["youtubeId"],
  mounted() {
    this.players = plyr.setup(".player-" + this.youtubeId);
  },
  methods: {
    initVid() {
      this.players = plyr.setup(".player-" + this.youtubeId);
    }
  },
  destroyed() {
    this.players[0].destroy();
  }
};
</script>

<style>
#videoHolder {
  width: 100%;
  height: 100%;
}
.video {
  width: 100%;
  height: 100%;
}
.plyr__progress__container {
  width: 60% !important;
}
</style>
